import * as React from "react";
import PropTypes from "prop-types";
import Table from "@material-ui/core/Table/Table";
import TableHead from "@material-ui/core/TableHead/TableHead";
import TableRow from "@material-ui/core/TableRow/TableRow";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableBody from "@material-ui/core/TableBody/TableBody";
import { withStyles } from "@material-ui/core";
import PercentageNumber from "../UI/PercentageNumber";
import HighLevelDisclosure from "../../containers/SummaryPDF/components/HighLevelDisclosure";
import { connect } from "react-redux";

const styles = (theme) => ({
  table: {
    width: "100%",
    tableLayout: "fixed",
  },
  tableCell: {
    padding: 2,
    fontSize: 12,
    "&.header": {
      wordWrap: "break-word",
      fontWeight: 500,
      color: theme.palette.primary.main,
    },
  },
});

const CyPortfolioCalendarYearReturnTable = (props) => {
  const {
    classes,
    calendarYearReturnData,
    portfolioDisplayName,
    showPercentageSign,
    benchmarkName,
    arraySplitIndex = 25
  } = props;
  const { startYear, CprCalYearReturn, BenchmarkCalYearReturn } =
    calendarYearReturnData;

  if (!calendarYearReturnData || !startYear || !CprCalYearReturn || !BenchmarkCalYearReturn) {
    return null;
  }

  return (
    <React.Fragment>
      <Table style={{ width: "100%" }}>
        <TableHead>
          <TableRow>
            <TableCell />
            {CprCalYearReturn.slice(0,arraySplitIndex).map((head, idx) => {
              return (
                <TableCell
                  key={idx}
                  variant="head"
                  align={"right"}
                  className={`${classes.tableCell} header`}
                >
                  {Number(startYear) + idx}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell align={"left"} className={`${classes.tableCell}`}>
              Cy Optimized Portfolio <br />({portfolioDisplayName})
              <sup>*</sup>
            </TableCell>
            {CprCalYearReturn.slice(0,arraySplitIndex).map((cprRet, i) => (
              <TableCell
                align={"right"}
                className={`${classes.tableCell}`}
                key={`cprRet-${i}`}
              >
                <PercentageNumber
                  value={cprRet}
                  showPercentageSign={showPercentageSign}
                />
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            <TableCell align={"left"} className={`${classes.tableCell}`}>
              {benchmarkName} <sup>**</sup>
            </TableCell>
            {BenchmarkCalYearReturn.slice(0,arraySplitIndex).map((spxRet, i) => (
              <TableCell
                align={"right"}
                className={`${classes.tableCell}`}
                key={`spxRet-${i}`}
              >
                <PercentageNumber
                  value={spxRet}
                  showPercentageSign={showPercentageSign}
                />
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
      {
        CprCalYearReturn.length > arraySplitIndex &&
        <Table style={{ width: "100%" }}>
          <TableHead>
            <TableRow>
              <TableCell />
              {CprCalYearReturn.slice(arraySplitIndex).map((head, idx) => {
                return (
                  <TableCell
                    key={idx}
                    variant="head"
                    align={"right"}
                    className={`${classes.tableCell} header`}
                  >
                    {Number(startYear) + idx + arraySplitIndex}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell align={"left"} className={`${classes.tableCell}`}>
                Cy Optimized Portfolio <br />({portfolioDisplayName})
                <sup>*</sup>
              </TableCell>
              {CprCalYearReturn.slice(arraySplitIndex).map((cprRet, i) => (
                <TableCell
                  align={"right"}
                  className={`${classes.tableCell}`}
                  key={`cprRet-${i}`}
                >
                  <PercentageNumber
                    value={cprRet}
                    showPercentageSign={showPercentageSign}
                  />
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              <TableCell align={"left"} className={`${classes.tableCell}`}>
                {benchmarkName} <sup>**</sup>
              </TableCell>
              {BenchmarkCalYearReturn.slice(arraySplitIndex).map((spxRet, i) => (
                <TableCell
                  align={"right"}
                  className={`${classes.tableCell}`}
                  key={`spxRet-${i}`}
                >
                  <PercentageNumber
                    value={spxRet}
                    showPercentageSign={showPercentageSign}
                  />
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      }

      <HighLevelDisclosure />
    </React.Fragment>
  );
};

CyPortfolioCalendarYearReturnTable.propTypes = {
  classes: PropTypes.object.isRequired,
  calendarYearReturnData: PropTypes.shape({
    startYear: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    CprCalYearReturn: PropTypes.array,
    BenchmarkCalYearReturn: PropTypes.array,
  }),
  portfolioDisplayName: PropTypes.string,
  showPercentageSign: PropTypes.bool,
  benchmarkName: PropTypes.string.isRequired,
};

CyPortfolioCalendarYearReturnTable.defaultProps = {
  benchmarkName: "S&P 500 Index",
};

const mapStateToProps = (state) => {
  return {
    appName: state.app.appName,
  };
};

export default withStyles(styles)(
  connect(mapStateToProps)(CyPortfolioCalendarYearReturnTable)
);



// WEBPACK FOOTER //
// ./src/components/Charts/CyPortfolioCalendarYearReturnTable.jsx